define('components/factory/models/ShareModel', [

], function() {

    var ShareModel = Backbone.Model.extend({
        defaults: {
            viewId: "share-id",         // Classic default viewId
            title: "",                  // Title of the view. If empty -> hidden
            showSprite: true,           // Show / Hide sprite
            spriteSize: "medium",       // Size of the sprite ( "small" || "medium" || "large" )
            spriteColor: "grey",        // Color of the sprite
            shareList: [],              // List of name ( "facebook" || "twitter" )
            facebookShare: null,        // Object for facebook share - https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4
                                        // -> link
                                        // -> name
                                        // -> caption
                                        // -> description
                                        // -> picture
            twitterShare: null,         // Object of twitter share - https://dev.twitter.com/web/tweet-button/web-intent
                                        // -> text
                                        // -> url
                                        // -> hashtags
                                        // -> via
            weiboShare: null,           // Object of weibo share
                                        // -> title
                                        // -> url
            shareLink: null,            // Share popin URL ( for mobile )
            copyText: false,            // Show input with "link" inside
            link: "",                   // text inside the input
            copyLink: false,            // Add button to copy link inside
            expandable: false,          // If true show share button that display all share when hover else show all share
            alignement: "horizontal",   // Display of share ( "horizontal" || "vertical" )
            isReady: false              // Classic isReady
        }
    });

    return ShareModel;
});
